module.exports = "pegasus_template/assets/film.png";